import React, { useEffect } from 'react';

const Autofill: React.FC = () => {
  useEffect(() => {
    document.title = 'OfferFlow | Autofill';
  }, []);

  return (
    <div>
    </div>
  );
};

export default Autofill;
